import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// tailwind-merge reads unknown `text-*` classes as colors, so `text-nv-tag text-nv-brand` would
// drop the font size. Register the Navigator type scale and radii from tailwind.config.ts.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "nv-title-md",
            "nv-body-lg",
            "nv-body-md",
            "nv-body-sm",
            "nv-caption",
            "nv-tag",
            "nv-label-md",
            "nv-button-md",
            "nv-button-sm",
          ],
        },
      ],
      rounded: [{ rounded: ["nv-xs", "nv-sm", "nv-md", "nv-lg", "nv-pill", "nv-chip", "nv-control", "nv-card"] }],
      shadow: [{ shadow: ["nv-card", "nv-float", "nv-popup"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(date: string, dateFormat: string = "YYYY-MM-DD HH:mm:ss") {
  const localTimezone = dayjs.tz.guess();
  return dayjs.utc(date).tz(localTimezone).format(dateFormat);
}

export const STATUS_CONFIG: Record<string, { label: string; bg: string; text: string, padding?: string }> = {
  init: { label: "초기화", bg: "bg-black/[0.06]", text: "text-[#202020]" },
  in_progress: {
    label: "진행 중",
    bg: "bg-[#FFAA72]",
    text: "text-[#000000]",
    padding: "px-[14.5px]",
  },
  under_review: {
    label: "검토 중",
    bg: "bg-[#E0B244]",
    text: "text-[#000000]",
    padding: "px-[12.5px]",
  },
  completed: {
    label: "완료",
    bg: "bg-[#43946C]",
    text: "text-[#000000]",
    padding: "px-[21px]",
  },
  rejected: {
    label: "거부됨",
    bg: "bg-[#CB3A31]",
    text: "text-[#000000]",
    padding: "px-[14.5px]"
  },
};
